export default __webpack_public_path__ + "static/media/friends.svg";